const idTypes = {
  SHOPPER_ID: 'shopperId',
  VISITOR_GUID: 'visitorGuid'
};

const DEFAULT_COHORT = 'ineligible';
const PARAMETER_LABEL = 'parameter';

module.exports = {
  idTypes,
  DEFAULT_COHORT,
  PARAMETER_LABEL
};
